import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_rgba_196_237_255_40 = setTheme(({ theme }) => `background-color: ${theme.colors.color_rgba_196_237_255_40}`);
